import React, { useState, useEffect } from 'react';
import axios from 'axios';

function LandingPage() {
  const [towns, setTowns] = useState([]);
  const [townSearch, setTownSearch] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedTown, setSelectedTown] = useState(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/filings/towns`)
      .then(res => setTowns(res.data))
      .catch(err => console.error('Could not load towns', err));
  }, []);

  const filteredTowns = towns.filter(t =>
    t.town_name.toLowerCase().includes(townSearch.toLowerCase())
  );

  const handleSelectTown = (town) => {
    setSelectedTown(town);
    setTownSearch(town.town_name);
    setShowDropdown(false);
  };

  const handleContinue = () => {
    window.location.href = `/form-select?town=${selectedTown.town_name}&town_code=${selectedTown.town_code}`;
  };

  // not yet active message
  if (selectedTown && !selectedTown.is_active) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h1 style={styles.title}>MAtownforms</h1>
          <div style={styles.inactiveBox}>
            <h2 style={styles.inactiveTitle}>🏛️ {selectedTown.town_name} is not active on matownforms.com</h2>
            <p style={styles.inactiveText}>
              It's 2026 dude! Contact your assessor's office and tell them to get with the program!
            </p>
            {(selectedTown.assessor_email || selectedTown.assessor_phone || selectedTown.assessor_website) && (
              <div style={styles.contactBox}>
                <p style={styles.contactTitle}>{selectedTown.town_name} Assessor's Office</p>
                {selectedTown.assessor_email && (
                  <p style={styles.contactItem}>
                    📧 <a href={`mailto:${selectedTown.assessor_email}`} style={styles.contactLink}>{selectedTown.assessor_email}</a>
                  </p>
                )}
                {selectedTown.assessor_phone && (
                  <p style={styles.contactItem}>📞 {selectedTown.assessor_phone}</p>
                )}
                {selectedTown.assessor_website && (
                  <p style={styles.contactItem}>
                    🌐 <a href={selectedTown.assessor_website} target="_blank" rel="noopener noreferrer" style={styles.contactLink}>{selectedTown.assessor_website}</a>
                  </p>
                )}
              </div>
            )}
            <button style={styles.secondaryButton} onClick={() => { setSelectedTown(null); setTownSearch(''); }}>
              Search a Different Town
            </button>
          </div>
          <p style={styles.signinLink}>
            <a href="/login" style={styles.anchor}>Sign in</a>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>MAtownforms</h1>
        <p style={styles.tagline}>free, secure filing for massachusetts town forms</p>

        <div style={styles.field}>
          <label style={styles.label}>Select your town</label>
          <input
            style={styles.input}
            type="text"
            placeholder="Type to search towns..."
            value={townSearch}
            onChange={(e) => {
              setTownSearch(e.target.value);
              setSelectedTown(null);
              setShowDropdown(true);
            }}
            onFocus={() => setShowDropdown(true)}
            autoComplete="off"
          />
          {showDropdown && townSearch.length > 0 && filteredTowns.length > 0 && (
            <div style={styles.dropdown}>
              {filteredTowns.slice(0, 8).map((town) => (
                <div
                  key={town.town_code}
                  style={styles.dropdownItem}
                  onClick={() => handleSelectTown(town)}
                >
                  {town.town_name}
                  {town.is_active && <span style={styles.activeBadge}>Active</span>}
                </div>
              ))}
            </div>
          )}
        </div>

        <button
          style={selectedTown && selectedTown.is_active ? styles.button : styles.buttonDisabled}
          onClick={handleContinue}
          disabled={!selectedTown || !selectedTown.is_active}
        >
          Continue
        </button>

        <p style={styles.signinLink}>
          <a href="/login" style={styles.anchor}>Sign in</a>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f4f6f9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
  },
  card: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '420px',
  },
  title: {
  color: '#1a3a5c',
  fontSize: '42px',
  marginBottom: '8px',
  textAlign: 'center',
  fontWeight: '700',
  fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
},
tagline: {
  fontSize: '13px',
  color: '#5a7a9c',
  textAlign: 'center',
  marginBottom: '48px',
  letterSpacing: '1.5px',
},
  field: {
    marginBottom: '20px',
    position: 'relative',
  },
  label: {
    display: 'block',
    marginBottom: '6px',
    color: '#333',
    fontSize: '14px',
    fontWeight: '600',
  },
  input: {
  width: '100%',
  padding: '14px 16px',
  borderRadius: '8px',
  border: '1.5px solid #c8d4e0',
  fontSize: '16px',
  boxSizing: 'border-box',
},
  dropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: '4px',
    zIndex: 100,
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  },
  dropdownItem: {
    padding: '10px 12px',
    fontSize: '14px',
    cursor: 'pointer',
    borderBottom: '1px solid #f0f0f0',
    color: '#333',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  activeBadge: {
    fontSize: '11px',
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
    padding: '2px 8px',
    borderRadius: '4px',
    fontWeight: '600',
  },
  button: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#1a3a5c',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
    marginBottom: '16px',
  },
  buttonDisabled: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#aaa',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'not-allowed',
    marginBottom: '16px',
  },
  signinLink: {
    textAlign: 'center',
    fontSize: '14px',
    color: '#555',
    marginTop: '8px',
  },
  anchor: {
    color: '#1a3a5c',
    fontWeight: '600',
  },
  inactiveBox: {
    textAlign: 'center',
    padding: '10px 0',
  },
  inactiveTitle: {
    color: '#1a3a5c',
    fontSize: '18px',
    marginBottom: '16px',
    lineHeight: '1.4',
  },
  inactiveText: {
    fontSize: '14px',
    color: '#333',
    marginBottom: '20px',
    lineHeight: '1.6',
  },
  contactBox: {
    backgroundColor: '#f4f6f9',
    padding: '16px',
    borderRadius: '4px',
    marginBottom: '20px',
    textAlign: 'left',
  },
  contactTitle: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#1a3a5c',
    marginBottom: '8px',
  },
  contactItem: {
    fontSize: '13px',
    color: '#333',
    marginBottom: '6px',
  },
  contactLink: {
    color: '#1a3a5c',
  },
  secondaryButton: {
    width: '100%',
    padding: '10px',
    backgroundColor: 'transparent',
    color: '#1a3a5c',
    border: '1px solid #1a3a5c',
    borderRadius: '4px',
    fontSize: '14px',
    cursor: 'pointer',
    marginBottom: '16px',
  },
};

export default LandingPage;
